export default __webpack_public_path__ + "static/media/you_win.b2a2467c.mp3";